(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pudel-launch-popup"] && !Shopify.designMode) return;
  try {
    (function(){
  const dialog=document.getElementById('pudel-launch-popup');
  if(!dialog||document.body.dataset.pudelOrdersOpen==='true')return;
  const form=dialog.querySelector('form');
  const result=document.getElementById('pudel-launch-result');
  const key='pudel-launch-15-v1';
  function showSuccess(){form.hidden=true;result.textContent=dialog.dataset.success;dialog.querySelector('[data-launch-close]').textContent=dialog.dataset.successBrowse}
  function remember(){try{sessionStorage.setItem(key,'dismissed')}catch(e){}}
  let leaving=false;
  function close(){
    if(leaving)return;
    remember();
    if(window.matchMedia('(prefers-reduced-motion: reduce)').matches){dialog.close();return}
    leaving=true;dialog.classList.add('is-leaving');
    window.setTimeout(function(){dialog.close();dialog.classList.remove('is-leaving');leaving=false},700);
  }
  dialog.querySelectorAll('[data-launch-close]').forEach(button=>button.addEventListener('click',close));
  dialog.addEventListener('cancel',function(event){event.preventDefault();close()});
  document.addEventListener('click',function(event){const link=event.target.closest('a[href="#launch-waitlist"]');if(link){event.preventDefault();dialog.showModal()}});
  let dismissed=false;try{const subscribed=localStorage.getItem(key)==='subscribed';dismissed=!!sessionStorage.getItem(key)||subscribed;if(subscribed)showSuccess()}catch(e){}
  if(!dismissed)dialog.showModal();
  form.addEventListener('submit',async function(event){
    event.preventDefault();if(!form.reportValidity())return;
    const button=form.querySelector('[type=submit]');button.disabled=true;result.textContent='';
    try{
      const response=await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=V7czVm',{
        method:'POST',headers:{'Content-Type':'application/vnd.api+json','revision':'2025-04-15'},
        body:JSON.stringify({data:{type:'subscription',attributes:{custom_source:'Pudel launch 15% popup',profile:{data:{type:'profile',attributes:{email:form.elements.email.value.trim(),properties:{source:'launch popup',launch_offer:'15% first order at launch',consent_form:'launch-popup-v22',consent_copy_version:'2026-09-24-launch15'}}}}},relationships:{list:{data:{type:'list',id:'Xb4JzD'}}}}})
      });
      if(!response.ok)throw new Error('Subscription failed');
      showSuccess();remember();try{localStorage.setItem(key,'subscribed')}catch(e){}
    }catch(error){result.textContent=dialog.dataset.error;button.disabled=false}
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pudel-launch-status"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit',function(event){
  if(document.body.dataset.pudelOrdersOpen==='true')return;
  const form=event.target;
  if(!(form instanceof HTMLFormElement))return;
  const action=new URL(form.action,window.location.origin).pathname;
  if(/\/cart\/add(?:\.js)?\/?$/.test(action)||event.submitter?.name==='checkout'){
    event.preventDefault();event.stopImmediatePropagation();
    document.getElementById('launch-waitlist')?.scrollIntoView({behavior:'smooth'});
  }
},true);
  } catch(e) { console.error(e); }
})();

})();
